import { useMemo } from 'react';
import { NoArgTask, OneArgTask, ThreeArgTask, TwoArgTask } from '~common/helper/mobx-tasks';

interface TaskCreator {
  <U>(): NoArgTask<U>;
  <U, T1>(): OneArgTask<U, T1>;
  <U, T1, T2>(): TwoArgTask<U, T1, T2>;
  <U, T1, T2, T3>(): ThreeArgTask<U, T1, T2, T3>;
}

interface TaskFactory {
  <U>(taskFactory: () => NoArgTask<U>): NoArgTask<U>;
  <U, T1>(taskFactory: () => OneArgTask<U, T1>): OneArgTask<U, T1>;
  <U, T1, T2>(taskFactory: () => TwoArgTask<U, T1, T2>): TwoArgTask<U, T1, T2>;
  <U, T1, T2, T3>(taskFactory: () => ThreeArgTask<U, T1, T2, T3>): ThreeArgTask<U, T1, T2, T3>;
}
/**
 * Use this hook to use a task in a component.
 * Returns a task in a mutable ref.
 *
 */
export const useTask: TaskFactory = (taskFactory: TaskCreator) => useMemo(taskFactory, []);



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/common/src/hook/use-task.ts